import React, { useState } from 'react';
import { Button, Typography, Container, Snackbar, Box, Paper } from '@mui/material';
import { sendVerificationEmail } from '../apis/apis';
import { useNavigate } from 'react-router-dom';

const VerifyEmail = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();
  const [isRequestInProgress, setIsRequestInProgress] = useState(false);

  const handleVerifyEmail = async () => {
    if (isRequestInProgress) return;
    setIsRequestInProgress(true);

    try {
      const result = await sendVerificationEmail();
      setSnackbarMessage("Verification email sent successfully!");
      setSnackbarOpen(true);
      setTimeout(() => {
        navigate('/signin');
      }, 3000);
    } catch (error) {
      setSnackbarMessage("Failed to send verification email.");
      setSnackbarOpen(true);
      if (error.message.includes("401")) {
        setTimeout(() => {
          navigate('/signin');
        }, 3000);
      }        
    } finally {
      setIsRequestInProgress(false);
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
        <Typography variant="h4" gutterBottom align="center">
          Verify Your Email
        </Typography>
        <Typography variant="body1" align="center" sx={{ marginBottom: 2 }}>
          Please click the button below to send a verification email to your registered address.
        </Typography>
        <Box textAlign="center">
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleVerifyEmail}
            sx={{ width: '100%' }}
          >
            Verify Email
          </Button>
        </Box>
      </Paper>
      <Snackbar 
        open={snackbarOpen} 
        autoHideDuration={6000} 
        onClose={handleSnackbarClose} 
        message={snackbarMessage}
      />
    </Container>
  );
};

export default VerifyEmail;
